import { DoneOutline, Info } from "@mui/icons-material";
import { Divider } from "@mui/material";
import React from "react";
import * as msg from "utils/constants/messages";

const UploadValidation = (props) => {
    return <>
        <div className="block-save" >
            <Info style={{ color: "var(--hti-magenta)" }} />
            <br />
            <div style={{ textAlign: "left" }}>
                <div>{msg.upload_mandatory}</div>
                <ul>
                    <li>Document Description</li>
                    {props.data.Entity_Details.classify.documentLevel === "Encounter" &&
                        <li>Encounter Selection</li>}
                    {props.data.Entity_Details.classify.documentLevel === "Order" &&
                        <li>Order Selection</li>}
                </ul>
            </div>
            <button
                className="apply-button"
                style={{ width: "70px" }}
                onClick={props.handleSubmit}
            >
                <p className="apply-button-text" >OK</p>
            </button>
        </div>
    </>
}

export default UploadValidation;